import React, { useEffect, useState } from "react";
import { HOME } from "@/constants/testIds";
import { fetchFaqs } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetchFaqs().then(setFaqs).catch(() => setFaqs([]));
  }, []);

  return (
    <section data-testid={HOME.faqSection} id="faq" className="bg-slate-50 border-b-2 border-slate-200">
      <div className="mx-auto max-w-5xl px-6 lg:px-8 py-20 lg:py-28">
        <div className="mb-12">
          <div className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-sky-600">FAQ</div>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-3 leading-tight">
            Straight answers, no salesy spin.
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="border-2 border-slate-900 bg-white divide-y-2 divide-slate-900"
          data-testid={HOME.faqAccordion}
        >
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-b-0">
              <AccordionTrigger
                className="px-6 py-5 hover:no-underline hover:bg-slate-50 text-left font-display font-bold text-base sm:text-lg text-slate-900"
                data-testid={`faq-trigger-${f.id}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 pt-0 text-slate-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
